import React from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "Components/Dashboard";
import AccountsSidebar from "Components/Common/AccountsSidebar";
import AppWrapper from "./AppWrapper";

function AccountsDashboard() {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const role = currentUser?.role_id;
  return (
    <>
        <AppWrapper sideBar={<AccountsSidebar/>}>
        <Routes>
          <Route
            path="/"
            element={
              role === 2|| role === 3 ? (
                  <Dashboard />
              ) : (
                currentUser == null && <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </AppWrapper>
    </>
  );
}
export default AccountsDashboard;